import axios from 'axios';
import { createRouter, createWebHistory } from 'vue-router';

import { getDataBody } from '@/utils/WebUtil';
import { usePromotionStore } from '@/stores/promotion';

import payments from './payments';
import goikoiList from './goikoi';
import ulinkList from './ulink';
import testList from './test/index';
import activity2025 from './activity/2025';

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    ...ulinkList,
    ...goikoiList,
    ...payments,
    ...testList,
    ...activity2025,
    {
      path: '/',
      name: 'home',
      component: () => import('../views/home/HomeView.vue'),
    },
    {
      path: '/gk/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/home/AboutView.vue'),
      alias: ['/about'],
    },
    {
      path: '/gk/reset-password',
      name: 'resetPassword',
      component: () => import('../views/password/ResetPassword.vue'),
    },
    {
      path: '/gk/verify-email',
      name: 'verifyEmail',
      component: () => import('../views/verify-email/verifyEmail.vue'),
    },
    {
      path: '/gk/deactivate-account',
      name: 'DeactivateAccount',
      component: () => import('../views/deactivate-account/DeactivateAccount.vue'),
    },
    {
      path: '/gk/dashboard/profile',
      name: 'DashboardProfile',
      component: () => import('../views/dashboard/DashboardProfile.vue'),
    },
    {
      path: '/gk/terms-of-use',
      name: 'TermsOfUse',
      component: () => import('../views/home/TermsOfUseView.vue'),
      alias: ['/terms-of-use'],
    },
    {
      path: '/gk/privacy-policy',
      name: 'PrivacyPolicy',
      component: () => import('../views/home/PrivacyPolicyView.vue'),
      alias: ['/privacy-policy'],
    },
    {
      path: '/gk/learning/tips',
      name: 'learningTips',
      // component: () => import('../views/NotFound.vue'),
      component: () => import('../views/learning-tips/RichPage.vue'),
    },
    {
      path: '/404',
      name: '404',
      component: () => import('../views/NotFound.vue'),
    },
    {
      path: '/review/index',
      name: 'review',
      component: () => import('../views/TheReview.vue'),
    },
    {
      path: '/:pathMatch(.*)',
      component: () => import('../views/NotFound.vue'),
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const promotionStore = usePromotionStore();
  const promote = promotionStore.currentPromotion;

  if (['/gk/vip/purchase/new', '/gk/vip/purchase'].includes(to.path)) {
    try {
      const sid = to.query.sid;
      const params = {
        sid,
        promote,
      };

      const res = await axios.get('/api/buy/promote/in-duration', { params });
      const dataBody = getDataBody(res);
      const { in_purchase_duration } = dataBody;

      if (in_purchase_duration) {
        next({
          path: `/gk/activity/vip/purchase/${promote}`,
          query: to.query,
          replace: true,
        });
      } else {
        next();
      }
    } catch (error) {
      next();
    }
  } else {
    next();
  }
});

export default router;
